import { TableModalActions } from 'constants/ActionsTypesTs'
import {
	IConfirmTableModalDataResponse,
	IGetTableModalDataResponse
} from 'models/TableModal'

export interface valueState {
	tableModalValues: IGetTableModalDataResponse | null
	tableModalAmount: IConfirmTableModalDataResponse | null
}

const initialState = {
	tableModalValues: null,
	tableModalAmount: null
}

function rootReducer(state: valueState = initialState, action: any) {
	switch (action.type) {
		case TableModalActions.GET_TABLE_MODAL_DATA:
		case TableModalActions.GET_TABLE_MODAL_PAGINATION:
		case TableModalActions.SELECT_TABLE_MODAL_DATA:
		case TableModalActions.SELECT_ALL_TABLE_MODAL_DATA:
			return {
				...state,
				tableModalValues: null
			}
		case TableModalActions.GET_TABLE_MODAL_DATA_SUCCESS:
		case TableModalActions.GET_TABLE_MODAL_PAGINATION_SUCCESS:
		case TableModalActions.SELECT_TABLE_MODAL_DATA_SUCCESS:
		case TableModalActions.SELECT_ALL_TABLE_MODAL_DATA_SUCCESS:
			return {
				...state,
				tableModalValues: action.response
			}
		case TableModalActions.CONFIRM_TABLE_MODAL_DATA:
			return {
				...state,
				tableModalAmount: null
			}
		case TableModalActions.CONFIRM_TABLE_MODAL_DATA_SUCCESS:
			return {
				...state,
				tableModalAmount: action.response
			}
		default:
			return state
	}
}

export default rootReducer
